(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  if (!customElements.get('pstv-collection-order')) {
    customElements.define(
      'pstv-collection-order',
      class extends HTMLElement {
        connectedCallback() {
          this.processed = new Map();
          this.observer = new MutationObserver(() => this.schedule());
          this.observe();
          this.schedule();
        }

        disconnectedCallback() {
          this.observer?.disconnect();
          cancelAnimationFrame(this.frame);
        }

        observe() {
          this.observer.observe(this, {
            childList: true,
            subtree: true
          });
        }

        schedule() {
          cancelAnimationFrame(this.frame);
          this.frame = requestAnimationFrame(() => this.updateOrder());
        }

        updateOrder() {
          if (!this.isConnected) return;

          const list = this.querySelector('results-list');
          const grid = list?.querySelector('[ref="grid"]');

          if (!grid || list.dataset.pstvMix !== 'true') return;

          const batches = new Map();

          for (const card of grid.children) {
            if (!card.hasAttribute('data-pstv-product')) continue;

            const page = card.dataset.page || '1';

            if (!batches.has(page)) batches.set(page, []);
            batches.get(page).push(card);
          }

          this.observer.disconnect();

          try {
            for (const [page, nodes] of batches) {
              const previousNodes = this.processed.get(page);

              if (
                previousNodes &&
                previousNodes.size === nodes.length &&
                nodes.every((node) => previousNodes.has(node))
              ) {
                continue;
              }

              const cards = nodes
                .slice()
                .sort((a, b) => {
                  const productDifference =
                    Number(a.dataset.pstvProductOrder) -
                    Number(b.dataset.pstvProductOrder);

                  return productDifference ||
                    Number(a.dataset.pstvColourIndex) -
                    Number(b.dataset.pstvColourIndex);
                })
                .map((node) => ({
                  node,
                  product: node.dataset.pstvProduct,
                  colour: node.dataset.pstvColour,
                  group: node.dataset.pstvGroup === 'neutral'
                    ? 'neutral'
                    : 'accent'
                }));

              const totals = { accent: 0, neutral: 0 };
              const used = { accent: 0, neutral: 0 };

              cards.forEach((card) => totals[card.group]++);

              const remaining = cards.slice();
              const ordered = [];

              while (remaining.length) {
                let bestIndex = 0;
                let bestScore = -Infinity;
                const previous = ordered[ordered.length - 1];

                remaining.forEach((card, index) => {
                  let score =
                    totals[card.group] * (ordered.length + 1) -
                    used[card.group] * cards.length;

                  if (previous?.colour === card.colour) {
                    score -= cards.length * 2;
                  }

                  if (previous?.product === card.product) {
                    score -= cards.length * cards.length * 2;
                  }

                  if (score > bestScore) {
                    bestScore = score;
                    bestIndex = index;
                  }
                });

                const chosen = remaining.splice(bestIndex, 1)[0];
                used[chosen.group]++;
                ordered.push(chosen);
              }

              const marker = document.createComment('pstv-order');
              grid.insertBefore(marker, nodes[0]);

              ordered.forEach(({ node }) => {
                grid.insertBefore(node, marker);
              });

              marker.remove();
              this.processed.set(page, new Set(nodes));
            }

            for (const page of this.processed.keys()) {
              if (!batches.has(page)) this.processed.delete(page);
            }
          } finally {
            if (this.isConnected) this.observe();
          }
        }
      }
    );
  }

  const url = new URL(window.location.href);

  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));

        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
